import type { PropsWithChildren } from 'react';
import React, { useState } from 'react';
import { useVyStepper } from '../../../hooks/use-vy-stepper';
import type { PlanInputForm } from '../../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { CREATE_PLAN_TABS } from '../../../pages/plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import type { PlanCreateReason } from '../create-plan-context-types/plan-create-reason';
import type { PlanCreationStep } from '../create-plan-context-types/plan-creation-step';
import { PLAN_CREATION_STEPS } from '../create-plan-context-types/plan-creation-step';
import { CreatePlanContext } from '../index';
import { usePlanCreationPlanPreview } from './hooks/use-plan-creation-plan-preview';

export type CreatePlanProviderProps<ExistingPlan extends PlanInputForm> = {
  planCreationReason: PlanCreateReason;
  defaultPlanCreationStep: PlanCreationStep;
  isCloningPlan?: boolean;
  existingPlan?: ExistingPlan;
  onFinalStep?: () => void;
  onFormSubmission?: (planInput: ExistingPlan) => Promise<void>;
};

export function CreatePlanProvider<ExistingPlan extends PlanInputForm>({
  children,
  planCreationReason,
  defaultPlanCreationStep,
  existingPlan,
  onFinalStep,
  onFormSubmission,
  isCloningPlan,
}: PropsWithChildren<CreatePlanProviderProps<ExistingPlan>>) {
  const [currentTab, setCurrentTab] = useState<CreatePlanTab>(CREATE_PLAN_TABS.serviceFees);
  const planPreview = usePlanCreationPlanPreview();
  const planCreationStepper = useVyStepper(defaultPlanCreationStep, PLAN_CREATION_STEPS, onFinalStep);

  return (
    <CreatePlanContext.Provider
      value={{
        existingPlan,
        planCreationReason,
        planCreationStepper,
        planPreview,
        createPlanTab: currentTab,
        setCreatePlanTab: setCurrentTab,
        onFormSubmission,
        isCloningPlan,
      }}
    >
      {children}
    </CreatePlanContext.Provider>
  );
}
